// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g9ZmE{display:flex;flex-direction:column}.MPiIw{margin-bottom:1rem}`, "",{"version":3,"sources":["webpack://./src/components/DatePicker/DatePicker.module.scss"],"names":[],"mappings":"AAAA,OACI,YAAA,CACA,qBAAA,CAEA,OACI,kBAAA","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n\n    &Title {\n        margin-bottom: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `g9ZmE`,
	"containerTitle": `MPiIw`
};
export default ___CSS_LOADER_EXPORT___;
